import { Input } from "@headlessui/react";
import StackedDate from "../../components/StackedDate";
import { DraftPeerReviewQuestionAnswer, PeerReviewPrintViewModel } from "./peerReviewsApiSlice";

interface Props {
	completedReviews: PeerReviewPrintViewModel[];
}

export default function PrintCompletedPeerReviewsDocument(props: Props) {
	const textClasses = "p-2 text-sm";
	const borderClasses = "border border-solid border-black";
	const getPageMargins = () => {
		return `@page { margin: 40px 50px 40px 50px !important; }`;
	};

	return (
		<div>
			<style>{getPageMargins()}</style>
			{props.completedReviews.map((review) => (
				<section className="break-after-page">
					<div className="flex items-center">
						<StackedDate className="mx-8" date={review.date} />
						<div>
							<h2>{review.promptName}</h2>
							<div className="text-sm">by {review.author}</div>
							<div className="text-sm">reviewed by {review.reviewer}</div>
							<div className="text-sm">for {review.courseName}</div>
						</div>
					</div>
					<table className="mt-3 w-full">
						<thead>
							<HeaderRow isGeneral={true} />
						</thead>
						<tbody>
							{review.questions
								.filter((r) => r.isGeneral)
								.map((row, index) => (
									<tr key={`general-${index}`}>
										<td className={`${textClasses} ${borderClasses} h-20`}>
											{row.question}
										</td>
										<td className={`${textClasses} ${borderClasses} h-20`}>
											{row.comment}
										</td>
									</tr>
								))}
						</tbody>
					</table>
					{review.questions.filter((r) => !r.isGeneral).length > 0 && (
						<table className="w-full">
							<thead>
								<HeaderRow isGeneral={false} />
							</thead>
							<tbody>
								{review.questions
									.filter((r) => !r.isGeneral)
									.map((row, index) => (
										<tr key={`other-${index}`}>
											<td className={`${textClasses} ${borderClasses} h-24`}>
												{row.question}
											</td>
											<td className={`${borderClasses} h-24`}>
												<div className="px-4 flex justify-between">
													<Input
														type="checkbox"
														checked={
															row.answer ===
															DraftPeerReviewQuestionAnswer.Yes
														}
													/>
													<Input
														type="checkbox"
														checked={
															row.answer ===
															DraftPeerReviewQuestionAnswer.Somewhat
														}
													/>
													<Input
														type="checkbox"
														checked={
															row.answer ===
															DraftPeerReviewQuestionAnswer.No
														}
													/>
												</div>
											</td>
											<td className={`${textClasses} ${borderClasses} h-24`}>
												{row.comment}
											</td>
										</tr>
									))}
							</tbody>
						</table>
					)}
				</section>
			))}
		</div>
	);
}

interface HeaderRowProps {
	isGeneral: boolean;
	className?: string;
}

function HeaderRow({ isGeneral, className }: HeaderRowProps) {
	const commonClasses = "text-sm p-1 border border-solid border-black !bg-primary-800/10";
	return (
		<tr>
			<th className={`${className} ${commonClasses} w-[25%]`}>Review Question</th>
			{!isGeneral && (
				<th className={`${className} ${commonClasses} text-center w-[25%]`}>
					Yes / Somewhat / No
				</th>
			)}
			<th className={`${className} ${commonClasses} min-w-1/2`}>Comment</th>
		</tr>
	);
}
